var _defs, _g, _text, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHillViewLogoBrown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9757",
    "data-name": "Group 9757",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 61.817,
    height: 112.643,
    viewBox: "0 0 61.817 112.643",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2660",
    "data-name": "Rectangle 2660",
    width: 61.817,
    height: 112.643,
    fill: "#776050"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9754",
    "data-name": "Group 9754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9753",
    "data-name": "Group 9753",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4842",
    "data-name": "Path 4842",
    d: "M61.814,46.429c0,5.426.009,10.852,0,16.278a28.656,28.656,0,0,1-1.149,8.867,33.366,33.366,0,0,1-5.974,10.64,29.513,29.513,0,0,1-11.795,8.811,31.092,31.092,0,0,1-22.125.55,30.5,30.5,0,0,1-9.633-5.363,27.7,27.7,0,0,1-6.911-8.173A32.238,32.238,0,0,1,.014,62.4c0-9.736.038-19.473-.013-29.209a37.987,37.987,0,0,1,1.608-12A33.583,33.583,0,0,1,6.5,12.147C10.842,6.058,16.94,2.884,23.958.962A26.067,26.067,0,0,1,35.684.432a34.374,34.374,0,0,1,8.234,2.506,31.293,31.293,0,0,1,13.2,11.607,27.862,27.862,0,0,1,4.64,15c.1,5.627.023,11.257.023,16.886h.035M1.291,46.64H1.24c0,5.427-.162,10.86.033,16.281.452,12.544,6.493,21.61,17.884,26.719,9.2,4.127,18.442,3.41,27.1-1.806,9.149-5.512,14.065-13.844,14.4-24.456.344-11,.1-22.011.061-33.018A27.972,27.972,0,0,0,58.29,19.287C51.66,3.957,33.23-3.457,17.759,4.473,7.552,9.7,1.936,18.119,1.342,29.6c-.294,5.665-.051,11.358-.051,17.039",
    transform: "translate(0 -0.001)",
    fill: "#776050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4843",
    "data-name": "Path 4843",
    d: "M39.9,1613.281h3c-.872.444-.808,1.3-.808,2.14,0,1.727.032,3.693,0,5.5h2.52a4.465,4.465,0,0,1,4.168,2.837v-8.336c0-.888.1-1.68-.824-2.14h3.011c-.887.444-.824,1.284-.824,2.14v8.875c0,.9-.079,1.68.824,2.124H48a1.64,1.64,0,0,0,.777-1.648,5.122,5.122,0,0,0-.254-.935,4.2,4.2,0,0,0-3.914-2.631h-2.52v3.09c0,.887-.079,1.7.824,2.124H39.968c.808-.412.761-1.316.761-2.124v-8.875c0-.888.079-1.664-.824-2.14",
    transform: "translate(-37.452 -1514.093)",
    fill: "#776050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4844",
    "data-name": "Path 4844",
    d: "M226.109,1617.869h.095v7.163c0,.634-.016,1.41.586,1.807h-2.266c.586-.4.586-1.189.586-1.807v-3.566c0-.761.206-2.694-.9-2.789Zm-1.189-3.36a.737.737,0,0,1,1.474,0,.717.717,0,0,1-.729.729.741.741,0,0,1-.745-.729",
    transform: "translate(-210.422 -1514.576)",
    fill: "#776050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4845",
    "data-name": "Path 4845",
    d: "M270.411,1602.117h.1v11.014a3.739,3.739,0,0,0,.143,1.268,1.307,1.307,0,0,0,.475.539h-2.282c.57-.38.57-1.2.57-1.807V1605.7a11.85,11.85,0,0,0-.079-1.949c-.1-.46-.3-.792-.792-.856Zm2.884-.951h.111v11.965a3.367,3.367,0,0,0,.143,1.268,1.172,1.172,0,0,0,.46.539h-2.266a1.242,1.242,0,0,0,.412-.523,3.175,3.175,0,0,0,.158-1.284v-8.415a9.7,9.7,0,0,0-.079-1.933.888.888,0,0,0-.792-.856Z",
    transform: "translate(-252.03 -1502.722)",
    fill: "#776050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4846",
    "data-name": "Path 4846",
    d: "M597.8,1617.869h.1v7.163c0,.634-.016,1.41.586,1.807H596.22c.586-.4.586-1.189.586-1.807v-3.566c0-.761.206-2.694-.9-2.789Zm-1.189-3.36a.737.737,0,0,1,1.474,0,.717.717,0,0,1-.729.729.741.741,0,0,1-.745-.729",
    transform: "translate(-559.265 -1514.576)",
    fill: "#776050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4847",
    "data-name": "Path 4847",
    d: "M649.594,1679.474a9.412,9.412,0,0,1,2.108-.206h.555l-.238,1.965a3.1,3.1,0,0,1-4.437,2.757c.143,1.807,1.125,3.645,3.186,3.645a2.98,2.98,0,0,0,2.25-1.03,3.69,3.69,0,0,1-3.09,1.965c-2.282,0-3.5-2.171-3.5-4.231,0-2.044,1-4.326,3.169-4.865m-2.044,4.184a2.7,2.7,0,0,0,1.331.349,2.872,2.872,0,0,0,2.71-1.949,1.737,1.737,0,0,0-.713-1.918,2.425,2.425,0,0,0-1.188-.317c-1.6,0-2.139,2.425-2.139,3.677Z",
    transform: "translate(-606.68 -1576.023)",
    fill: "#776050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4848",
    "data-name": "Path 4848",
    d: "M751.849,1684.939h2.345c-.523.333-.333,1.094-.143,1.553l2.155,5.705,1.569-3.344a.982.982,0,0,1,.9-.634,1.209,1.209,0,0,1,.333.047l-.919-2.345a1.91,1.91,0,0,0-.761-.983h2.393a1.045,1.045,0,0,0-.4,1.379l2.266,5.705,2.314-6.006c.19-.523.38-.7-.1-1.062,0-.016,0-.016-.016-.016h1.315a2.248,2.248,0,0,0-.9,1.141l-3.011,7.813-2.028-5.214a.735.735,0,0,0-.475-.206.806.806,0,0,0-.681.555l-2.25,4.818-2.884-7.559a2.172,2.172,0,0,0-1.03-1.347",
    transform: "translate(-705.624 -1581.345)",
    fill: "#776050"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "H",
    transform: "translate(18.415 44.214)",
    fill: "#776050",
    fontSize: 31,
    fontFamily: "Rawgly-Regular, Rawgly"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "H"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9756",
    "data-name": "Group 9756"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9755",
    "data-name": "Group 9755",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4849",
    "data-name": "Path 4849",
    d: "M300.837,847.312c1.782.72,1.713,2.6,1.062,4.111l-3.255,7.606v-.006l-1.736,4.046h0c-.081.192-.165.386-.251.585l-3.529,8.154-6.1-14.6c-.723-1.759-2.481-5.36-2.768-7.4h0c-.616-2.432,2.763-2.531,3.128-2.534l-9.1.033c1.919.857,2.809,3.015,3.563,4.8L291.963,876.3l10.552-24.7c.582-1.473,1.61-3.666,3.221-4.283Z",
    transform: "translate(-261.183 -795.186)",
    fill: "#776050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4850",
    "data-name": "Path 4850",
    d: "M413.288,1613.3c.826.334.794,1.207.492,1.906l-1.509,3.527v0l-.805,1.876h0q-.057.133-.116.271l-1.636,3.781-2.828-6.767a19.12,19.12,0,0,1-1.283-3.431h0c-.286-1.128,1.281-1.173,1.45-1.175l-4.217.016a3.841,3.841,0,0,1,1.652,2.224l4.686,11.215,4.893-11.454c.27-.683.747-1.7,1.493-1.986Z",
    transform: "translate(-378.068 -1514.093)",
    fill: "#776050"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHillViewLogoBrown);
export default __webpack_public_path__ + "static/media/hill_view_logo_brown.be3a09b6621b792850ce30e14568f74a.svg";
export { ForwardRef as ReactComponent };